import { useState } from 'react';
import { useDebounce } from './use-debounce';
/**
 * Free-text search state where the input reflects every keystroke immediately, but the committed term the query reads
 * only follows after a debounce — so a search doesn't refire the server query on every character.
 */
export const useDebouncedSearch = (debounceMs = 300) => {
    const [searchInput, setSearchInput] = useState('');
    const [search, setSearch] = useState('');
    const commitSearch = useDebounce((value) => setSearch(value), { timeoutMs: debounceMs }, []);
    const onSearch = (value) => {
        setSearchInput(value);
        commitSearch(value);
    };
    const clearSearch = () => {
        setSearchInput('');
        setSearch('');
        // Replaces any commit still pending from typing, so the cleared term cannot be restored a moment later.
        commitSearch('');
    };
    return { searchInput, onSearch, search, clearSearch };
};
